import React from 'react'
import { useNavigate } from 'react-router-dom'
import { VacancyForm } from '@/components/vacancy/VacancyForm'

const CreateVacancy: React.FC = () => {
  const navigate = useNavigate()

  return (
    <main className="container-custom py-8">
      <h1 className="mb-6 text-2xl font-bold text-secondary-900">Новая вакансия</h1>
      <VacancyForm onSuccess={() => navigate('/dashboard')} onCancel={() => navigate(-1)} />
    </main>
  )
}

export default CreateVacancy
